import { render } from "./IconParticipants.vue?vue&type=template&id=1904ddf1"
import script from "./IconParticipants.vue?vue&type=script&lang=js"
export * from "./IconParticipants.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__